import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { api } from "../../api";
import { CATEGORY_FIELDS } from "../../admin/fields";
import { RecordForm } from "../../admin/RecordForm";

type Cat = { id: string; slug: string; name: string; programCount: number; children: { id: string; slug: string; name: string; programCount: number }[] };

export function CategoriesAdmin() {
  const qc = useQueryClient();
  const [editing, setEditing] = useState<string | null>(null);
  const q = useQuery({ queryKey: ["categories"], queryFn: () => api<{ categories: Cat[] }>("/api/directory/categories") });
  const reload = () => qc.invalidateQueries({ queryKey: ["categories"] });
  const tops = q.data?.categories ?? [];
  const parentOptions = tops.map((c) => ({ value: c.id, label: c.name }));
  const all = tops.flatMap((c) => [{ ...c, parentId: null as string | null }, ...c.children.map((s) => ({ ...s, parentId: c.id }))]);

  return (
    <div className="mx-auto grid max-w-5xl gap-4 lg:grid-cols-2">
      <section className="card"><h1 className="mb-3 text-lg font-semibold">Categories</h1>
        {q.error && <p role="alert" className="mb-2 text-sm text-red-600">{(q.error as Error).message}</p>}
        <ul className="text-sm">{tops.map((c) => (
          <li key={c.id} className="mb-2">
            <button className="font-semibold hover:underline" onClick={() => setEditing(c.id)}>{c.name}</button> <span className="text-xs text-slate-500">{c.programCount}</span>
            <ul className="ml-4">{c.children.map((s) => <li key={s.id}><button className="hover:underline" onClick={() => setEditing(s.id)}>{s.name}</button> <span className="text-xs text-slate-500">{s.programCount}</span></li>)}</ul>
          </li>
        ))}</ul>
        <button className="btn-primary mt-2" onClick={() => setEditing("new")}>New category</button>
      </section>
      {editing && (() => {
        const cur = all.find((c) => c.id === editing);
        return (
          <section className="card"><h2 className="mb-3 font-semibold">{cur ? `Edit ${cur.name}` : "New category"}</h2>
            <RecordForm key={editing} fields={CATEGORY_FIELDS} sendAll={!cur} initial={cur ? { name: cur.name, slug: cur.slug, parentId: cur.parentId ?? "" } : {}}
              submitLabel={cur ? "Save" : "Create"} selectOptions={{ parentId: parentOptions.filter((p) => p.value !== editing) }}
              onSave={async (v) => {
                if (cur) await api(`/api/admin/directory/categories/${cur.id}`, { method: "PATCH", body: v });
                else { const r = await api<{ id: string }>("/api/admin/directory/categories", { method: "POST", body: v }); setEditing(r.id); }
                reload();
              }} />
          </section>
        );
      })()}
    </div>
  );
}
